<template>
  <div class="new-management-company">
    <v-breadcrumbs class="new-management-company__breadcrumbs px-0 pt-0 pb-2" :items="breadcrumbs" />
    <div class="new-management-company__header">
      <v-icon color="primary" class="new-management-company__header-icon">mdi-domain-plus</v-icon>
      <h1 class="new-management-company__title">{{ $route.meta.title }}</h1>
    </div>
    <v-card class="new-management-company__card" flat outlined>
      <v-card-text class="pa-4">
        <v-form ref="form" v-model="valid" lazy-validation>
          <h2 class="new-management-company__section-title mb-3">
            <v-icon left small>mdi-information-outline</v-icon>
            Данные управляющей компании
          </h2>
          <v-row>
            <v-col cols="12" sm="6" class="new-management-company__field-col">
              <v-text-field
                v-model="formDoorphone.name"
                label="Название"
                outlined
                dense
                flat
                hide-details
                prepend-inner-icon="mdi-tag-outline"
                class="new-management-company__field"
                :rules="[() => !!formDoorphone.name || 'Обязательное поле']"
              />
            </v-col>
            <v-col cols="12" sm="6" class="new-management-company__field-col">
              <v-text-field
                v-model="formDoorphone.address"
                label="Адрес"
                outlined
                dense
                flat
                hide-details
                prepend-inner-icon="mdi-map-marker-outline"
                class="new-management-company__field"
                :rules="[() => !!formDoorphone.address || 'Обязательное поле']"
              />
            </v-col>
            <v-col cols="12" sm="6" class="new-management-company__field-col">
              <v-text-field
                v-model="formDoorphone.contacts"
                label="Контакты"
                outlined
                dense
                flat
                hide-details
                prepend-inner-icon="mdi-phone-outline"
                class="new-management-company__field"
                :rules="[() => !!formDoorphone.contacts || 'Обязательное поле']"
              />
            </v-col>
            <v-col cols="12" sm="6" class="new-management-company__field-col">
              <v-autocomplete
                v-model="formDoorphone.groupId"
                label="Компания-собственник"
                :items="managementsGroup"
                item-text="name"
                item-value="id"
                outlined
                dense
                flat
                clearable
                hide-details
                prepend-inner-icon="mdi-office-building-outline"
                class="new-management-company__field"
                :rules="[() => !!formDoorphone.groupId || 'Обязательное поле']"
              />
            </v-col>
          </v-row>
          <div class="new-management-company__actions">
            <v-btn
              color="primary"
              class="text-none"
              rounded
              :disabled="!valid"
              @click.prevent="save"
            >
              <v-icon left>mdi-content-save-outline</v-icon>
              Сохранить
            </v-btn>
            <v-btn
              color="primary"
              outlined
              rounded
              class="text-none ml-2"
              @click.prevent="returnManagement"
            >
              <v-icon left>mdi-close</v-icon>
              Отменить
            </v-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'NewManagementCompany',
  props: ['id'],
  data () {
    return {
      valid: true,
      formDoorphone: {
        name: '',
        address: '',
        contacts: '',
        groupId: '',
      },
      breadcrumbs: [
        { text: 'Управляющие компании', disabled: false, href: '/management' },
        { text: 'Создание управляющей компании', disabled: true, href: '#' },
      ],
    };
  },
  created () {
    this.loadManagementGroup();
  },
  computed: {
    ...mapGetters({
      managementsGroup: 'GroupManagementCompany/managementsGroup',
    }),
  },
  methods: {
    ...mapActions({
      createManagementCompany: 'ManagementCompany/createManagementCompany',
      getManagementsGroups: 'GroupManagementCompany/getManagementsGroups',
    }),
    loadManagementGroup () {
      this.getManagementsGroups({ pagination: 1 })
        .then((response) => {
          this.totalCompaniesGroup = response.meta.total;
        })
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке групп управляющих компаний');
        });
    },
    save () {
      this.$refs.form.validate();
      this.$nextTick(() => {
        if (this.valid) {
          const dataManagementCompany = {
            name: this.formDoorphone.name,
            address: this.formDoorphone.address,
            contacts: this.formDoorphone.contacts,
            group_id: this.formDoorphone.groupId,
          };
          this.createManagementCompany(dataManagementCompany)
            .then(() => {
              this.$router.push({ name: 'Management' });
              this.$flash_success('Изменения успешно сохранены');
            })
            .catch(() => {
              this.$flash_warning('Ошибка при создании управляющей компании');
            });
        }
      });
    },
    returnManagement () {
      this.$router.push({ name: 'Management' });
    },
  },
};
</script>

<style lang="scss" scoped>
.new-management-company__breadcrumbs {
  margin-bottom: 4px;
}

.new-management-company__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.new-management-company__header-icon {
  flex-shrink: 0;
}

.new-management-company__title {
  font-size: 1.5rem;
  font-weight: 500;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.01em;
}

.new-management-company__card {
  border-radius: 12px;
}

.new-management-company__section-title {
  font-size: 1rem;
  font-weight: 500;
  color: #546e7a;
}

.new-management-company__field-col {
  padding-top: 8px;
}

.new-management-company__field ::v-deep .v-input__prepend-inner .v-icon {
  color: rgba(0, 0, 0, 0.5);
}

.new-management-company__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 32px;
}
</style>
